import { render, staticRenderFns } from "./vestidas.vue?vue&type=template&id=b8b3c0e6&"
import script from "./vestidas.vue?vue&type=script&lang=js&"
export * from "./vestidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b3c0e6')) {
      api.createRecord('b8b3c0e6', component.options)
    } else {
      api.reload('b8b3c0e6', component.options)
    }
    module.hot.accept("./vestidas.vue?vue&type=template&id=b8b3c0e6&", function () {
      api.rerender('b8b3c0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/vestidas.vue"
export default component.exports